<p class="global-title">
  Refund requests
</p>
<div class="menu-container">
  <div class="menu-item">
    <p-button label="Create new request" routerLink="/management/refund-request-new"></p-button>
  </div>
</div>
<ng-container>
  <p-table selectionMode="single" [value]="requests">
    <ng-template pTemplate="header">
      <tr>
        <th>
          LVMS ID
        </th>
        <th>
          Name
        </th>
        <th>
          Paid
        </th>
        <th>
          Approved
        </th>
        <th>
          Amount
        </th>
        <th>
          Created at
        </th>
        <th>
          Download PDF
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-request>
      <tr [pSelectableRow]="request">
        <td>
          <a routerLink="/management/refund-request-edit/{{request.id}}">
            {{request.lvmsBookingId}}
          </a>
        </td>
        <td>
          <a routerLink="/management/refund-request-edit/{{request.id}}">
          {{request.studentName}}
          </a>
        </td>
        <td>
          <span *ngIf="request.isPaid">
            <i class="pi pi-dollar"></i>
          </span>
        </td>
        <td class="name-box">
          <span *ngIf="request.isApproved">
            <i class="pi pi-check"></i>
          </span>
        </td>
        <td>
          {{request.amount}}
        </td>
        <td>
          {{request.created | date: 'dd/MM/yyyy'}}
        </td>
        <td>
          <a (click)="downloadPdf(request)" class="download-link">
            {{"Refund_Request_" + request.id}}
            <i class="pi pi-file-pdf"></i>
          </a>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>